export const ALLERGY_LIST_REQUEST = 'ALLERGY_LIST_REQUEST';
export const ALLERGY_LIST_SUCCESS = 'ALLERGY_LIST_SUCCESS';
export const ALLERGY_LIST_FAIL = 'ALLERGY_LIST_FAIL';
